import { PropsWithChildren, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PathConstants from "../../../routes/path-constants";

export const RequireAppealId = ({ children }: PropsWithChildren) => {
  const [shouldDisplayChildren, setShouldDisplayChildren] = useState(false);
  const navigate = useNavigate();
  const appealId = sessionStorage.getItem("appealId");

  useEffect(() => {
    if (appealId) {
      setShouldDisplayChildren(true);
    } else {
      navigate(PathConstants.Appeals);
    }
  }, [navigate, appealId]);

  if (!shouldDisplayChildren) {
    return null;
  }

  return children;
};
